import userApi from '../../api/user'
import * as types from '../mutation-types'
import Dialog from '../../plugins/dialog.js'
import Tools from '../../tools/tools.js'
import activity from '../../api/activity.js'
const localStorageUserCityKey = 'USER_CITY'
const localStorageUserId = 'USER_INFO'

const state = {
  userInfo: {},
  userCity: {},
  baseInfo: { pvareaId: '' },
  certificateInfo: [],
  certificateImages: []
}

// getters
const getters = {
  userInfo: function (state) {
    return state.userInfo
  },
  userCity: function (state) {
    return state.userCity
  },
  baseInfo: function (state) {
    return state.baseInfo
  },
  certificateInfo: function (state) {
    return state.certificateInfo
  },
  certificateImages: function (state) {
    return state.certificateImages
  }
}

// actions
const actions = {
  getUserInfo({ commit, getters }) {
    userApi.getUserInfo({ pvareaId: getters.baseInfo.pvareaId }).then(res => {
      if (!res) {
        return
      }
      if (res.data.returnCode === 0) {
        commit(types.RECEIVE_USER_INFO, { info: res.data.result })
        localStorage.setItem(
          localStorageUserId,
          JSON.stringify(res.data.result)
        )
      } else {
        if (window.entrance.name != 'WxMini') {
          Dialog.toast({ title: res.data.message })
        }
      }
    })
  },
  changeUserCity({ commit }, { city }) {
    commit(types.CHANGE_USER_CITY, { city })
  },
  async initCity({ commit }) {
    try {
      let city;
      if (window.entrance.name === 'mainapp' || window.entrance.name === 'WxMini') {
        let urlCityId = Tools.getQueryString('cityId')
        let res = await activity.getCityNameByCityId(urlCityId)
        if (urlCityId) {
          city = {
            cityId: Number(urlCityId),
            cityName: res.data
          }
        } else {
          city = {
            cityId: 110100,
            cityName: '北京'
          }
        }
      } else {
        let localStorageUserCity = localStorage.getItem(localStorageUserCityKey)
        if (localStorageUserCity) {
          city = JSON.parse(localStorageUserCity)
        } else {
          city = {
            cityId: 110100,
            cityName: '北京'
          }
        }
      }
      commit(types.CHANGE_USER_CITY, { city: city })
      // Environment.getSyncCity(city.cityId)
    } catch (error) {
      console.log(error)
      let city = {
        cityId: 110100,
        cityName: '北京'
      }
      commit(types.CHANGE_USER_CITY, { city: city })
    }
  },
  initBaseInfo: function ({ commit }) {
    commit(types.INIT_BASE_INFO)
  },
  getCertificateInfo({ commit }) {
    userApi.getCertificateInfo().then(res => {
      if (!res) {
        return
      }
      if (res.data.returnCode === 0) {
        commit(types.RECEIVE_CERTIFICATE_LIST, { list: res.data.result })
      } else {
        Dialog.toast({ title: res.data.message })
      }
    })
  },
  getCertificateImages({ commit }, certificateId) {
    userApi.getCertificateImages({ certificateId: certificateId }).then(res => {
      if (!res) {
        return
      }
      if (res.data.returnCode === 0) {
        commit(types.RECEIVE_CERTIFICATE_IMAGES, { list: res.data.result })
      } else {
        Dialog.toast({ title: res.data.message })
      }
    })
  },
  resetCertificateImages({ commit }) {
    commit(types.RECEIVE_CERTIFICATE_IMAGES, { list: [] })
  },
  certificateSubmit({ dispatch }, param) {
    userApi.certificateSubmit(param).then(res => {
      if (!res) {
        return
      }
      if (res.data.returnCode === 0) {
        Dialog.toast({ title: '提交成功！' })
        dispatch('getCertificateInfo')
        dispatch('getCertificateImages', param.certificateId)
      } else {
        Dialog.toast({ title: res.data.message })
      }
    })
  }
}

// mutations
const mutations = {
  [types.RECEIVE_USER_INFO](state, { info }) {
    state.userInfo = info
    let localStorageUserCity = localStorage.getItem(localStorageUserCityKey)
    let cityId
    let cityName
    if (localStorageUserCity !== null) {
      let userLastSelectedCity = JSON.parse(localStorageUserCity)
      cityId = userLastSelectedCity.cityId
      cityName = userLastSelectedCity.cityName
    } else {
      cityId = info.userCityId
      cityName = info.userCityName
      localStorage.setItem(
        localStorageUserCityKey,
        JSON.stringify({ cityId, cityName })
      )
    }
    state.userCity = {
      cityId: cityId,
      cityName: cityName
    }
  },
  [types.CHANGE_USER_CITY](state, { city }) {
    console.log('---->city', city)
    localStorage.setItem(localStorageUserCityKey, JSON.stringify(city))
    state.userCity = city
  },
  [types.INIT_BASE_INFO](state) {
    let pvareaId = Tools.getQueryString('pvareaId')
    if (!pvareaId) {
      pvareaId = '0'
    }
    state.baseInfo = { pvareaId: pvareaId }
  },
  [types.RECEIVE_CERTIFICATE_LIST](state, { list }) {
    state.certificateInfo = list
  },
  [types.RECEIVE_CERTIFICATE_IMAGES](state, { list }) {
    state.certificateImages = list
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js